// Einheitliche Statuswerte (analog Status bei Projekten)
export const INVENTAR_STATUS_VALUES = [
  "verfügbar",
  "ausgeliehen",
  "in_reparatur",
  "vergeben",
  "verbraucht",
];

const STATUS_LABELS = {
  verfügbar: "Verfügbar",
  ausgeliehen: "Ausgeliehen",
  in_reparatur: "In Reparatur",
  vergeben: "Vergeben",
  verbraucht: "Verbraucht",
};

export const INVENTAR_STATUS_OPTIONS = INVENTAR_STATUS_VALUES.map((v) => ({ value: v, label: STATUS_LABELS[v] || v }));
